import React, { useCallback, useEffect, useState } from "react";
import { Spinner } from "react-bootstrap";
import faradayApi from "../../Services/faradayApi";
import CustoEconomia from "../Dashboard/CustoEconomia";
import ConsumeLine from "../ConsumeLine";

export default function ConsolidatedConsumeLine({ selectedIds }) {
  const [dashboardData, setDashboardData] = useState(null);
  const [error, setError] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  const loadDashboard = useCallback(async () => {
    setError(false);
    setIsLoading(true);

    try {
      const response = await faradayApi.post(
        "measuring-point/consolidated-dashboard",
        { measuringPointIds: selectedIds }
      );
      setDashboardData(response.data);
    } catch (requestError) {
      setError(true);
    } finally {
      setIsLoading(false);
    }
  }, [selectedIds]);

  useEffect(() => {
    loadDashboard();
  }, [loadDashboard]);

  if (isLoading) {
    return (
      <div className="right-text-center" style={{ minHeight: 180 }}>
        <Spinner animation="border" role="status" />
      </div>
    );
  }

  if (error) {
    return (
      <div
        className="right-text-center"
        style={{ flexDirection: "column", gap: 16 }}
      >
        <p>Não foi possível carregar os dados consolidados.</p>
        <button
          type="button"
          className="btn btn-primary"
          onClick={loadDashboard}
        >
          Tentar novamente
        </button>
      </div>
    );
  }

  return (
    <>
      <CustoEconomia
        totalCativo={dashboardData?.totalCostCativo}
        totalLivre={dashboardData?.totalCostLivre}
        economy={dashboardData?.accumulatedEconomy}
        description="Custos e economia para as unidades selecionadas"
      />
      <ConsumeLine
        profiles={[]}
        isConsolidated
        consolidatedData={dashboardData}
      />
    </>
  );
}
